<p-toast />
<div class="default-layout">
  <app-header (menuToggle)="toggleDrawer()"></app-header>

  <main class="flex-sb full-width">
    @if (menuItems !== undefined && menuItems.length > 0) {
      <aside class="sidebar">
        <p-panelmenu [model]="menuItems" />
      </aside>
    }
    
    <section class="content full-width">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
